import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=674baa0f&"
import script from "./Document.vue?vue&type=script&lang=js&"
export * from "./Document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('674baa0f')) {
      api.createRecord('674baa0f', component.options)
    } else {
      api.reload('674baa0f', component.options)
    }
    module.hot.accept("./Document.vue?vue&type=template&id=674baa0f&", function () {
      api.rerender('674baa0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/fuel-resources/Document.vue"
export default component.exports